export interface CountryCode {
  code: string;
  dialCode: string;
  name: string;
  flag: string;
  mask: string;
  placeholder: string;
}

export const COUNTRY_CODES: CountryCode[] = [
    {
        code: 'BR',
        dialCode: '+55',
        name: 'Brasil',
        flag: '🇧🇷',
        mask: '(00) 00000-0000',
        placeholder: '(11) 11111-1111'
      },
    {
        code: 'AF',
        dialCode: '+93',
        name: 'Afeganistão',
        flag: '🇦🇫',
        mask: '00 000 0000',
        placeholder: '70 123 4567'
      },
      {
        code: 'AL',
        dialCode: '+355',
        name: 'Albânia',
        flag: '🇦🇱',
        mask: '000 000 000',
        placeholder: '67 123 456'
      },
      {
        code: 'DZ',
        dialCode: '+213',
        name: 'Argélia',
        flag: '🇩🇿',
        mask: '00 000 0000',
        placeholder: '55 123 4567'
      },
      {
        code: 'AS',
        dialCode: '+1684',
        name: 'Samoa Americana',
        flag: '🇦🇸',
        mask: '000 0000',
        placeholder: '733 1234'
      },
      {
        code: 'AD',
        dialCode: '+376',
        name: 'Andorra',
        flag: '🇦🇩',
        mask: '000 000',
        placeholder: '312 345'
      },
      {
        code: 'AO',
        dialCode: '+244',
        name: 'Angola',
        flag: '🇦🇴',
        mask: '000 000 000',
        placeholder: '923 123 456'
      },
      {
        code: 'AI',
        dialCode: '+1264',
        name: 'Anguilla',
        flag: '🇦🇮',
        mask: '000 0000',
        placeholder: '584 1234'
      },
      {
        code: 'AQ',
        dialCode: '+672',
        name: 'Antártida',
        flag: '🇦🇶',
        mask: '00 0000',
        placeholder: '10 1234'
      },
      {
        code: 'AG',
        dialCode: '+1268',
        name: 'Antígua e Barbuda',
        flag: '🇦🇬',
        mask: '000 0000',
        placeholder: '464 1234'
      },
      {
        code: 'AR',
        dialCode: '+54',
        name: 'Argentina',
        flag: '🇦🇷',
        mask: '000 000-0000',
        placeholder: '11 2345-6789'
      },
      {
        code: 'AM',
        dialCode: '+374',
        name: 'Armênia',
        flag: '🇦🇲',
        mask: '00 000000',
        placeholder: '77 123456'
      },
      {
        code: 'AW',
        dialCode: '+297',
        name: 'Aruba',
        flag: '🇦🇼',
        mask: '000 0000',
        placeholder: '592 1234'
      },
      {
        code: 'AU',
        dialCode: '+61',
        name: 'Austrália',
        flag: '🇦🇺',
        mask: '0000 000 000',
        placeholder: '412 345 678'
      },
      {
        code: 'AT',
        dialCode: '+43',
        name: 'Áustria',
        flag: '🇦🇹',
        mask: '0000 000000',
        placeholder: '664 123456'
      },
      {
        code: 'AZ',
        dialCode: '+994',
        name: 'Azerbaijão',
        flag: '🇦🇿',
        mask: '00 000 00 00',
        placeholder: '40 123 45 67'
      },
      {
        code: 'BS',
        dialCode: '+1242',
        name: 'Bahamas',
        flag: '🇧🇸',
        mask: '000 0000',
        placeholder: '359 1234'
      },
      {
        code: 'BH',
        dialCode: '+973',
        name: 'Bahrein',
        flag: '🇧🇭',
        mask: '0000 0000',
        placeholder: '3612 3456'
      },
      {
        code: 'BD',
        dialCode: '+880',
        name: 'Bangladesh',
        flag: '🇧🇩',
        mask: '00000-000000',
        placeholder: '1812-345678'
      },
      {
        code: 'BB',
        dialCode: '+1246',
        name: 'Barbados',
        flag: '🇧🇧',
        mask: '000 0000',
        placeholder: '246 1234'
      },
      {
        code: 'BY',
        dialCode: '+375',
        name: 'Bielorrússia',
        flag: '🇧🇾',
        mask: '00 0000000',
        placeholder: '29 1234567'
      },
      {
        code: 'BE',
        dialCode: '+32',
        name: 'Bélgica',
        flag: '🇧🇪',
        mask: '0000 00 00 00',
        placeholder: '470 12 34 56'
      },
      {
        code: 'BZ',
        dialCode: '+501',
        name: 'Belize',
        flag: '🇧🇿',
        mask: '000-0000',
        placeholder: '622-1234'
      },
      {
        code: 'BJ',
        dialCode: '+229',
        name: 'Benin',
        flag: '🇧🇯',
        mask: '00 00 0000',
        placeholder: '90 01 2345'
      },
      {
        code: 'BM',
        dialCode: '+1441',
        name: 'Bermudas',
        flag: '🇧🇲',
        mask: '000 0000',
        placeholder: '370 1234'
      },
      {
        code: 'BT',
        dialCode: '+975',
        name: 'Butão',
        flag: '🇧🇹',
        mask: '00 000 000',
        placeholder: '17 123 456'
      },
      {
        code: 'BO',
        dialCode: '+591',
        name: 'Bolívia',
        flag: '🇧🇴',
        mask: '00000000',
        placeholder: '71234567'
      },
      {
        code: 'BQ',
        dialCode: '+599',
        name: 'Bonaire',
        flag: '🇧🇶',
        mask: '000 0000',
        placeholder: '717 1234'
      },
      {
        code: 'BA',
        dialCode: '+387',
        name: 'Bósnia e Herzegovina',
        flag: '🇧🇦',
        mask: '00 000 000',
        placeholder: '61 123 456'
      },
      {
        code: 'BW',
        dialCode: '+267',
        name: 'Botsuana',
        flag: '🇧🇼',
        mask: '00 000 000',
        placeholder: '71 123 456'
      },
      {
        code: 'BV',
        dialCode: '+47',
        name: 'Ilha Bouvet',
        flag: '🇧🇻',
        mask: '000 00 000',
        placeholder: '412 34 567'
      },

      {
        code: 'IO',
        dialCode: '+246',
        name: 'Território Britânico do Oceano Índico',
        flag: '🇮🇴',
        mask: '000 0000',
        placeholder: '380 1234'
      },
      {
        code: 'BN',
        dialCode: '+673',
        name: 'Brunei',
        flag: '🇧🇳',
        mask: '000 0000',
        placeholder: '712 3456'
      },
      {
        code: 'BG',
        dialCode: '+359',
        name: 'Bulgária',
        flag: '🇧🇬',
        mask: '000 000 000',
        placeholder: '87 123 456'
      },
      {
        code: 'BF',
        dialCode: '+226',
        name: 'Burkina Faso',
        flag: '🇧🇫',
        mask: '00 00 0000',
        placeholder: '70 01 2345'
      },
      {
        code: 'BI',
        dialCode: '+257',
        name: 'Burundi',
        flag: '🇧🇮',
        mask: '00 00 0000',
        placeholder: '79 12 3456'
      },
      {
        code: 'KH',
        dialCode: '+855',
        name: 'Camboja',
        flag: '🇰🇭',
        mask: '00 000 000',
        placeholder: '92 123 456'
      },
      {
        code: 'CM',
        dialCode: '+237',
        name: 'Camarões',
        flag: '🇨🇲',
        mask: '0000 0000',
        placeholder: '6712 3456'
      },
      {
        code: 'CA',
        dialCode: '+1',
        name: 'Canadá',
        flag: '🇨🇦',
        mask: '(000) 000-0000',
        placeholder: '(613) 555-5555'
      },
      {
        code: 'CV',
        dialCode: '+238',
        name: 'Cabo Verde',
        flag: '🇨🇻',
        mask: '000 00 00',
        placeholder: '991 12 34'
      },
      {
        code: 'CF',
        dialCode: '+236',
        name: 'República Centro-Africana',
        flag: '🇨🇫',
        mask: '00 00 0000',
        placeholder: '70 01 2345'
      },
      {
        code: 'TD',
        dialCode: '+235',
        name: 'Chade',
        flag: '🇹🇩',
        mask: '00 00 00 00',
        placeholder: '63 01 23 45'
      },
      {
        code: 'CL',
        dialCode: '+56',
        name: 'Chile',
        flag: '🇨🇱',
        mask: '0 0000 0000',
        placeholder: '9 8765 4321'
      },
      {
        code: 'CN',
        dialCode: '+86',
        name: 'China',
        flag: '🇨🇳',
        mask: '000 0000 0000',
        placeholder: '131 2345 6789'
      },
      {
        code: 'CX',
        dialCode: '+61',
        name: 'Ilhas Christmas',
        flag: '🇨🇽',
        mask: '0000 000 000',
        placeholder: '412 345 678'
      },
      {
        code: 'CC',
        dialCode: '+61',
        name: 'Ilhas Cocos',
        flag: '🇨🇨',
        mask: '0000 000 000',
        placeholder: '412 345 678'
      },
      {
        code: 'CO',
        dialCode: '+57',
        name: 'Colômbia',
        flag: '🇨🇴',
        mask: '000 0000000',
        placeholder: '300 1234567'
      },
      {
        code: 'KM',
        dialCode: '+269',
        name: 'Comores',
        flag: '🇰🇲',
        mask: '000 00 00',
        placeholder: '321 23 45'
      },
      {
        code: 'CG',
        dialCode: '+242',
        name: 'Congo',
        flag: '🇨🇬',
        mask: '00 000 0000',
        placeholder: '06 123 4567'
      },
      {
        code: 'CD',
        dialCode: '+243',
        name: 'Congo (RDC)',
        flag: '🇨🇩',
        mask: '000 000 000',
        placeholder: '812 345 678'
      },
      {
        code: 'CK',
        dialCode: '+682',
        name: 'Ilhas Cook',
        flag: '🇨🇰',
        mask: '00 000',
        placeholder: '71 234'
      },
      {
        code: 'CR',
        dialCode: '+506',
        name: 'Costa Rica',
        flag: '🇨🇷',
        mask: '0000 0000',
        placeholder: '8312 3456'
      },
      {
        code: 'HR',
        dialCode: '+385',
        name: 'Croácia',
        flag: '🇭🇷',
        mask: '00 000 0000',
        placeholder: '91 234 5678'
      },
      {
        code: 'CU',
        dialCode: '+53',
        name: 'Cuba',
        flag: '🇨🇺',
        mask: '0 0000000',
        placeholder: '5 1234567'
      },
      {
        code: 'CW',
        dialCode: '+599',
        name: 'Curaçao',
        flag: '🇨🇼',
        mask: '000 0000',
        placeholder: '951 1234'
      },
      {
        code: 'CY',
        dialCode: '+357',
        name: 'Chipre',
        flag: '🇨🇾',
        mask: '00 000000',
        placeholder: '96 123456'
      },
      {
        code: 'CZ',
        dialCode: '+420',
        name: 'República Tcheca',
        flag: '🇨🇿',
        mask: '000 000 000',
        placeholder: '601 123 456'
      },
      {
        code: 'DK',
        dialCode: '+45',
        name: 'Dinamarca',
        flag: '🇩🇰',
        mask: '00 00 00 00',
        placeholder: '20 12 34 56'
      },
      {
        code: 'DJ',
        dialCode: '+253',
        name: 'Djibuti',
        flag: '🇩🇯',
        mask: '00 00 00 00',
        placeholder: '77 12 34 56'
      },
      {
        code: 'DM',
        dialCode: '+1767',
        name: 'Dominica',
        flag: '🇩🇲',
        mask: '000 0000',
        placeholder: '225 1234'
      },
      {
        code: 'DO',
        dialCode: '+1809',
        name: 'República Dominicana',
        flag: '🇩🇴',
        mask: '000 000 0000',
        placeholder: '809 234 5678'
      },
      {
        code: 'TL',
        dialCode: '+670',
        name: 'Timor-Leste',
        flag: '🇹🇱',
        mask: '0000 0000',
        placeholder: '7723 4567'
      },
      {
        code: 'EC',
        dialCode: '+593',
        name: 'Equador',
        flag: '🇪🇨',
        mask: '00 000 0000',
        placeholder: '99 123 4567'
      },
      {
        code: 'EG',
        dialCode: '+20',
        name: 'Egito',
        flag: '🇪🇬',
        mask: '0000 0000000',
        placeholder: '100 1234567'
      },
      {
        code: 'SV',
        dialCode: '+503',
        name: 'El Salvador',
        flag: '🇸🇻',
        mask: '0000 0000',
        placeholder: '7012 3456'
      },
      {
        code: 'GB',
        dialCode: '+44',
        name: 'Reino Unido',
        flag: '🇬🇧',
        mask: '00000 000000',
        placeholder: '07900 123456'
      },
      {
        code: 'GQ',
        dialCode: '+240',
        name: 'Guiné Equatorial',
        flag: '🇬🇶',
        mask: '000 000 000',
        placeholder: '222 123 456'
      },
      {
        code: 'ER',
        dialCode: '+291',
        name: 'Eritreia',
        flag: '🇪🇷',
        mask: '0 000 000',
        placeholder: '7 123 456'
      },
      {
        code: 'EE',
        dialCode: '+372',
        name: 'Estônia',
        flag: '🇪🇪',
        mask: '0000 0000',
        placeholder: '5123 4567'
      },
      {
        code: 'SZ',
        dialCode: '+268',
        name: 'Essuatíni',
        flag: '🇸🇿',
        mask: '0000 0000',
        placeholder: '7612 3456'
      },
      {
        code: 'ET',
        dialCode: '+251',
        name: 'Etiópia',
        flag: '🇪🇹',
        mask: '00 000 0000',
        placeholder: '91 123 4567'
      },
      {
        code: 'FO',
        dialCode: '+298',
        name: 'Ilhas Faroé',
        flag: '🇫🇴',
        mask: '000 000',
        placeholder: '211 234'
      },
      {
        code: 'FK',
        dialCode: '+500',
        name: 'Ilhas Falkland',
        flag: '🇫🇰',
        mask: '00000',
        placeholder: '31234'
      },
      {
        code: 'FJ',
        dialCode: '+679',
        name: 'Fiji',
        flag: '🇫🇯',
        mask: '000 0000',
        placeholder: '701 2345'
      },
      {
        code: 'FI',
        dialCode: '+358',
        name: 'Finlândia',
        flag: '🇫🇮',
        mask: '00 0000000',
        placeholder: '40 1234567'
      },
      {
        code: 'FR',
        dialCode: '+33',
        name: 'França',
        flag: '🇫🇷',
        mask: '0 00 00 00 00',
        placeholder: '6 12 34 56 78'
      },
      {
        code: 'GF',
        dialCode: '+594',
        name: 'Guiana Francesa',
        flag: '🇬🇫',
        mask: '00000 0000',
        placeholder: '69420 1234'
      },
      {
        code: 'TF',
        dialCode: '+262',
        name: 'Territórios Franceses do Sul',
        flag: '🇹🇫',
        mask: '00000 0000',
        placeholder: '26200 1234'
      },
      {
        code: 'GA',
        dialCode: '+241',
        name: 'Gabão',
        flag: '🇬🇦',
        mask: '0 00 00 00',
        placeholder: '6 01 23 45'
      },
      {
        code: 'GM',
        dialCode: '+220',
        name: 'Gâmbia',
        flag: '🇬🇲',
        mask: '000 0000',
        placeholder: '301 2345'
      },
      {
        code: 'GE',
        dialCode: '+995',
        name: 'Geórgia',
        flag: '🇬🇪',
        mask: '000 000 000',
        placeholder: '555 123 456'
      },
      {
        code: 'DE',
        dialCode: '+49',
        name: 'Alemanha',
        flag: '🇩🇪',
        mask: '0000 0000000',
        placeholder: '1111 1111111'
      },
      {
        code: 'GH',
        dialCode: '+233',
        name: 'Gana',
        flag: '🇬🇭',
        mask: '00 000 0000',
        placeholder: '23 123 4567'
      },
      {
        code: 'GI',
        dialCode: '+350',
        name: 'Gibraltar',
        flag: '🇬🇮',
        mask: '00000000',
        placeholder: '11111111'
      },
      {
        code: 'GR',
        dialCode: '+30',
        name: 'Grécia',
        flag: '🇬🇷',
        mask: '000 000 0000',
        placeholder: '111 111 1111'
      },
      {
        code: 'GL',
        dialCode: '+299',
        name: 'Groenlândia',
        flag: '🇬🇱',
        mask: '00 00 00',
        placeholder: '22 11 33'
      },
      {
        code: 'GD',
        dialCode: '+1473',
        name: 'Granada',
        flag: '🇬🇩',
        mask: '000 0000',
        placeholder: '473 1234'
      },
      {
        code: 'GP',
        dialCode: '+590',
        name: 'Guadalupe',
        flag: '🇬🇵',
        mask: '0000 00 00 00',
        placeholder: '690 12 34 56'
      },
      {
        code: 'GU',
        dialCode: '+1671',
        name: 'Guam',
        flag: '🇬🇺',
        mask: '000 0000',
        placeholder: '671 1234'
      },
      {
        code: 'GT',
        dialCode: '+502',
        name: 'Guatemala',
        flag: '🇬🇹',
        mask: '0000 0000',
        placeholder: '5123 4567'
      },
      {
        code: 'GN',
        dialCode: '+224',
        name: 'Guiné',
        flag: '🇬🇳',
        mask: '00 000 0000',
        placeholder: '60 123 4567'
      },
      {
        code: 'GW',
        dialCode: '+245',
        name: 'Guiné-Bissau',
        flag: '🇬🇼',
        mask: '00 00000',
        placeholder: '95 12345'
      },
      {
        code: 'GY',
        dialCode: '+592',
        name: 'Guiana',
        flag: '🇬🇾',
        mask: '000 0000',
        placeholder: '609 1234'
      },
      {
        code: 'HT',
        dialCode: '+509',
        name: 'Haiti',
        flag: '🇭🇹',
        mask: '00 00 0000',
        placeholder: '34 10 1234'
      },
      {
        code: 'HM',
        dialCode: '+672',
        name: 'Ilhas Heard e McDonald',
        flag: '🇭🇲',
        mask: '00 0000',
        placeholder: '10 1234'
      },
      {
        code: 'HN',
        dialCode: '+504',
        name: 'Honduras',
        flag: '🇭🇳',
        mask: '0000-0000',
        placeholder: '9123-4567'
      },
      {
        code: 'HK',
        dialCode: '+852',
        name: 'Hong Kong',
        flag: '🇭🇰',
        mask: '0000 0000',
        placeholder: '5123 4567'
      },
      {
        code: 'HU',
        dialCode: '+36',
        name: 'Hungria',
        flag: '🇭🇺',
        mask: '00 000 0000',
        placeholder: '20 123 4567'
      },
      {
        code: 'IS',
        dialCode: '+354',
        name: 'Islândia',
        flag: '🇮🇸',
        mask: '000 0000',
        placeholder: '123 4567'
      },
      {
        code: 'IN',
        dialCode: '+91',
        name: 'Índia',
        flag: '🇮🇳',
        mask: '00000 00000',
        placeholder: '98765 43210'
      },
      {
        code: 'ID',
        dialCode: '+62',
        name: 'Indonésia',
        flag: '🇮🇩',
        mask: '000 000 000',
        placeholder: '812 345 678'
      },
      {
        code: 'IR',
        dialCode: '+98',
        name: 'Irã',
        flag: '🇮🇷',
        mask: '000 000 0000',
        placeholder: '912 345 6789'
      },
      {
        code: 'IQ',
        dialCode: '+964',
        name: 'Iraque',
        flag: '🇮🇶',
        mask: '000 000 0000',
        placeholder: '781 234 5678'
      },
      {
        code: 'IE',
        dialCode: '+353',
        name: 'Irlanda',
        flag: '🇮🇪',
        mask: '00 000 0000',
        placeholder: '85 123 4567'
      },
      {
        code: 'IL',
        dialCode: '+972',
        name: 'Israel',
        flag: '🇮🇱',
        mask: '000 000 0000',
        placeholder: '50 123 4567'
      },
      {
        code: 'IT',
        dialCode: '+39',
        name: 'Itália',
        flag: '🇮🇹',
        mask: '000 000 0000',
        placeholder: '312 345 6789'
      },
      {
        code: 'CI',
        dialCode: '+225',
        name: 'Costa do Marfim',
        flag: '🇨🇮',
        mask: '00 000 000',
        placeholder: '12 345 678'
      },
      {
        code: 'JM',
        dialCode: '+1 876',
        name: 'Jamaica',
        flag: '🇯🇲',
        mask: '000 0000',
        placeholder: '876 5432'
      },
      {
        code: 'JP',
        dialCode: '+81',
        name: 'Japão',
        flag: '🇯🇵',
        mask: '00 0000 0000',
        placeholder: '90 1234 5678'
      },
      {
        code: 'JO',
        dialCode: '+962',
        name: 'Jordânia',
        flag: '🇯🇴',
        mask: '0 0000 0000',
        placeholder: '7 1234 5678'
      },
      {
        code: 'KZ',
        dialCode: '+7',
        name: 'Cazaquistão',
        flag: '🇰🇿',
        mask: '000 000 0000',
        placeholder: '701 123 4567'
      },
      {
        code: 'KE',
        dialCode: '+254',
        name: 'Quênia',
        flag: '🇰🇪',
        mask: '000 000000',
        placeholder: '712 345678'
      },
      {
        code: 'KI',
        dialCode: '+686',
        name: 'Quiribati',
        flag: '🇰🇮',
        mask: '00000',
        placeholder: '12345'
      },
      {
        code: 'KW',
        dialCode: '+965',
        name: 'Kuwait',
        flag: '🇰🇼',
        mask: '000 00000',
        placeholder: '500 12345'
      },
      {
        code: 'KG',
        dialCode: '+996',
        name: 'Quirguistão',
        flag: '🇰🇬',
        mask: '000 000 000',
        placeholder: '700 123 456'
      },
      {
        code: 'LA',
        dialCode: '+856',
        name: 'Laos',
        flag: '🇱🇦',
        mask: '00 00 000 000',
        placeholder: '20 23 123 456'
      },
      {
        code: 'LV',
        dialCode: '+371',
        name: 'Letônia',
        flag: '🇱🇻',
        mask: '00 000 000',
        placeholder: '21 234 567'
      },
      {
        code: 'LB',
        dialCode: '+961',
        name: 'Líbano',
        flag: '🇱🇧',
        mask: '00 000 000',
        placeholder: '71 123 456'
      },
      {
        code: 'LS',
        dialCode: '+266',
        name: 'Lesoto',
        flag: '🇱🇸',
        mask: '0000 0000',
        placeholder: '5012 3456'
      },
      {
        code: 'LR',
        dialCode: '+231',
        name: 'Libéria',
        flag: '🇱🇷',
        mask: '000 000 0000',
        placeholder: '770 123 4567'
      },
      {
        code: 'LY',
        dialCode: '+218',
        name: 'Líbia',
        flag: '🇱🇾',
        mask: '00 0000000',
        placeholder: '21 1234567'
      },
      {
        code: 'LI',
        dialCode: '+423',
        name: 'Liechtenstein',
        flag: '🇱🇮',
        mask: '000 000 000',
        placeholder: '234 567 890'
      },
      {
        code: 'LT',
        dialCode: '+370',
        name: 'Lituânia',
        flag: '🇱🇹',
        mask: '000 00000',
        placeholder: '612 34567'
      },
      {
        code: 'LU',
        dialCode: '+352',
        name: 'Luxemburgo',
        flag: '🇱🇺',
        mask: '000 000 000',
        placeholder: '621 123 456'
      },
      {
        code: 'MO',
        dialCode: '+853',
        name: 'Macau',
        flag: '🇲🇴',
        mask: '0000 0000',
        placeholder: '6612 3456'
      },
      {
        code: 'MK',
        dialCode: '+389',
        name: 'Macedônia',
        flag: '🇲🇰',
        mask: '00 000 000',
        placeholder: '72 123 456'
      },
      {
        code: 'MG',
        dialCode: '+261',
        name: 'Madagascar',
        flag: '🇲🇬',
        mask: '00 00 000 00',
        placeholder: '32 12 345 67'
      },
      {
        code: 'MW',
        dialCode: '+265',
        name: 'Malawi',
        flag: '🇲🇼',
        mask: '0000 00 00 00',
        placeholder: '9912 34 56 78'
      },
      {
        code: 'MY',
        dialCode: '+60',
        name: 'Malásia',
        flag: '🇲🇾',
        mask: '00-000 0000',
        placeholder: '12-345 6789'
      },
      {
        code: 'MV',
        dialCode: '+960',
        name: 'Maldivas',
        flag: '🇲🇻',
        mask: '000-0000',
        placeholder: '771-2345'
      },
      {
        code: 'ML',
        dialCode: '+223',
        name: 'Mali',
        flag: '🇲🇱',
        mask: '00 00 00 00',
        placeholder: '65 12 34 56'
      },
      {
        code: 'MT',
        dialCode: '+356',
        name: 'Malta',
        flag: '🇲🇹',
        mask: '0000 0000',
        placeholder: '9612 3456'
      },
      {
        code: 'MH',
        dialCode: '+692',
        name: 'Ilhas Marshall',
        flag: '🇲🇭',
        mask: '000-0000',
        placeholder: '123-4567'
      },
      {
        code: 'MQ',
        dialCode: '+596',
        name: 'Martinica',
        flag: '🇲🇶',
        mask: '000 00 00 00',
        placeholder: '696 12 34 56'
      },
      {
        code: 'MR',
        dialCode: '+222',
        name: 'Mauritânia',
        flag: '🇲🇷',
        mask: '00 00 00 00',
        placeholder: '22 12 34 56'
      },
      {
        code: 'MU',
        dialCode: '+230',
        name: 'Maurício',
        flag: '🇲🇺',
        mask: '000 0000',
        placeholder: '512 3456'
      },
      {
        code: 'YT',
        dialCode: '+262',
        name: 'Mayotte',
        flag: '🇾🇹',
        mask: '000 000 000',
        placeholder: '639 123 456'
      },
      {
        code: 'MX',
        dialCode: '+52',
        name: 'México',
        flag: '🇲🇽',
        mask: '000 000 0000',
        placeholder: '811 234 5678'
      },
      {
        code: 'FM',
        dialCode: '+691',
        name: 'Micronésia',
        flag: '🇫🇲',
        mask: '000 0000',
        placeholder: '320 1234'
      },
      {
        code: 'MD',
        dialCode: '+373',
        name: 'Moldávia',
        flag: '🇲🇩',
        mask: '0000 0000',
        placeholder: '621 12345'
      },
      {
        code: 'MC',
        dialCode: '+377',
        name: 'Mônaco',
        flag: '🇲🇨',
        mask: '00 00 00 00',
        placeholder: '12 34 56 78'
      },
      {
        code: 'MN',
        dialCode: '+976',
        name: 'Mongólia',
        flag: '🇲🇳',
        mask: '0000 0000',
        placeholder: '8812 3456'
      },
      {
        code: 'ME',
        dialCode: '+382',
        name: 'Montenegro',
        flag: '🇲🇪',
        mask: '00 000 000',
        placeholder: '67 123 456'
      },
      {
        code: 'MS',
        dialCode: '+1 664',
        name: 'Montserrat',
        flag: '🇲🇸',
        mask: '000 0000',
        placeholder: '492 3456'
      },
      {
        code: 'MA',
        dialCode: '+212',
        name: 'Marrocos',
        flag: '🇲🇦',
        mask: '0000-000000',
        placeholder: '6123-456789'
      },
      {
        code: 'MZ',
        dialCode: '+258',
        name: 'Moçambique',
        flag: '🇲🇿',
        mask: '00 000 0000',
        placeholder: '82 123 4567'
      },
      {
        code: 'MM',
        dialCode: '+95',
        name: 'Myanmar (Birmânia)',
        flag: '🇲🇲',
        mask: '0 000 000',
        placeholder: '9 123 456'
      },
      {
        code: 'NA',
        dialCode: '+264',
        name: 'Namíbia',
        flag: '🇳🇦',
        mask: '00 000 0000',
        placeholder: '81 123 4567'
      },
      {
        code: 'NR',
        dialCode: '+674',
        name: 'Nauru',
        flag: '🇳🇷',
        mask: '000 0000',
        placeholder: '555 1234'
      },
      {
        code: 'NP',
        dialCode: '+977',
        name: 'Nepal',
        flag: '🇳🇵',
        mask: '000-0000000',
        placeholder: '984-1234567'
      },
      {
        code: 'NL',
        dialCode: '+31',
        name: 'Países Baixos',
        flag: '🇳🇱',
        mask: '00 00000000',
        placeholder: '61 23456789'
      },
      {
        code: 'NC',
        dialCode: '+687',
        name: 'Nova Caledônia',
        flag: '🇳🇨',
        mask: '00 00 00',
        placeholder: '75 12 34'
      },
      {
        code: 'NZ',
        dialCode: '+64',
        name: 'Nova Zelândia',
        flag: '🇳🇿',
        mask: '000 000 0000',
        placeholder: '21 123 4567'
      },
      {
        code: 'NI',
        dialCode: '+505',
        name: 'Nicarágua',
        flag: '🇳🇮',
        mask: '0000 0000',
        placeholder: '8123 4567'
      },
      {
        code: 'NE',
        dialCode: '+227',
        name: 'Níger',
        flag: '🇳🇪',
        mask: '00 00 00 00',
        placeholder: '93 12 34 56'
      },
      {
        code: 'NG',
        dialCode: '+234',
        name: 'Nigéria',
        flag: '🇳🇬',
        mask: '000 000 0000',
        placeholder: '802 123 4567'
      },
      {
        code: 'NU',
        dialCode: '+683',
        name: 'Niue',
        flag: '🇳🇺',
        mask: '0000',
        placeholder: '1234'
      },
      {
        code: 'NF',
        dialCode: '+672',
        name: 'Ilha Norfolk',
        flag: '🇳🇫',
        mask: '00000',
        placeholder: '38123'
      },
      {
        code: 'KP',
        dialCode: '+850',
        name: 'Coreia do Norte',
        flag: '🇰🇵',
        mask: '000-000 0000',
        placeholder: '912-345 6789'
      },
      {
        code: 'MP',
        dialCode: '+1 670',
        name: 'Ilhas Marianas do Norte',
        flag: '🇲🇵',
        mask: '000 0000',
        placeholder: '234 5678'
      },
      {
        code: 'NO',
        dialCode: '+47',
        name: 'Noruega',
        flag: '🇳🇴',
        mask: '000 00 000',
        placeholder: '412 34 567'
      },
      {
        code: 'OM',
        dialCode: '+968',
        name: 'Omã',
        flag: '🇴🇲',
        mask: '0000 0000',
        placeholder: '9212 3456'
      },
      {
        code: 'PK',
        dialCode: '+92',
        name: 'Paquistão',
        flag: '🇵🇰',
        mask: '000 0000000',
        placeholder: '301 2345678'
      },
      {
        code: 'PW',
        dialCode: '+680',
        name: 'Palau',
        flag: '🇵🇼',
        mask: '000 0000',
        placeholder: '620 1234'
      },
      {
        code: 'PS',
        dialCode: '+970',
        name: 'Palestina',
        flag: '🇵🇸',
        mask: '0000 000 000',
        placeholder: '5992 123 456'
      },
      {
        code: 'PA',
        dialCode: '+507',
        name: 'Panamá',
        flag: '🇵🇦',
        mask: '0000-0000',
        placeholder: '6123-4567'
      },
      {
        code: 'PG',
        dialCode: '+675',
        name: 'Papua Nova Guiné',
        flag: '🇵🇬',
        mask: '000 00 000',
        placeholder: '712 34 567'
      },
      {
        code: 'PY',
        dialCode: '+595',
        name: 'Paraguai',
        flag: '🇵🇾',
        mask: '000 000000',
        placeholder: '961 123456'
      },
      {
        code: 'PE',
        dialCode: '+51',
        name: 'Peru',
        flag: '🇵🇪',
        mask: '000 000 000',
        placeholder: '912 345 678'
      },
      {
        code: 'PH',
        dialCode: '+63',
        name: 'Filipinas',
        flag: '🇵🇭',
        mask: '000 000 0000',
        placeholder: '912 345 6789'
      },
      {
        code: 'PN',
        dialCode: '+64',
        name: 'Pitcairn',
        flag: '🇵🇳',
        mask: '000 000 0000',
        placeholder: '21 123 4567'
      },
      {
        code: 'PL',
        dialCode: '+48',
        name: 'Polônia',
        flag: '🇵🇱',
        mask: '000 000 000',
        placeholder: '512 345 678'
      },
      {
        code: 'PT',
        dialCode: '+351',
        name: 'Portugal',
        flag: '🇵🇹',
        mask: '00 000 0000',
        placeholder: '11 111 1111'
      },
      {
        code: 'PR',
        dialCode: '+1 787',
        name: 'Porto Rico',
        flag: '🇵🇷',
        mask: '000 0000',
        placeholder: '234 5678'
      },
      {
        code: 'QA',
        dialCode: '+974',
        name: 'Catar',
        flag: '🇶🇦',
        mask: '0000 0000',
        placeholder: '3312 3456'
      },
      {
        code: 'RE',
        dialCode: '+262',
        name: 'Reunião',
        flag: '🇷🇪',
        mask: '000 000 000',
        placeholder: '692 123 456'
      },
      {
        code: 'RO',
        dialCode: '+40',
        name: 'Romênia',
        flag: '🇷🇴',
        mask: '000 000 000',
        placeholder: '712 345 678'
      },
      {
        code: 'RU',
        dialCode: '+7',
        name: 'Rússia',
        flag: '🇷🇺',
        mask: '000 000-00-00',
        placeholder: '912 345-67-89'
      },
      {
        code: 'RW',
        dialCode: '+250',
        name: 'Ruanda',
        flag: '🇷🇼',
        mask: '000 000 000',
        placeholder: '720 123 456'
      },
      {
        code: 'WS',
        dialCode: '+685',
        name: 'Samoa',
        flag: '🇼🇸',
        mask: '00 00000',
        placeholder: '72 12345'
      },
      {
        code: 'ST',
        dialCode: '+239',
        name: 'São Tomé e Príncipe',
        flag: '🇸🇹',
        mask: '00 00000',
        placeholder: '98 12345'
      },
      {
        code: 'SA',
        dialCode: '+966',
        name: 'Arábia Saudita',
        flag: '🇸🇦',
        mask: '0 0000 0000',
        placeholder: '5 0123 4567'
      },
      {
        code: 'SN',
        dialCode: '+221',
        name: 'Senegal',
        flag: '🇸🇳',
        mask: '00 000 0000',
        placeholder: '77 123 4567'
      },
      {
        code: 'RS',
        dialCode: '+381',
        name: 'Sérvia',
        flag: '🇷🇸',
        mask: '00 0000000',
        placeholder: '60 1234567'
      },
      {
        code: 'SC',
        dialCode: '+248',
        name: 'Seicheles',
        flag: '🇸🇨',
        mask: '0 000 000',
        placeholder: '2 510 123'
      },
      {
        code: 'SL',
        dialCode: '+232',
        name: 'Serra Leoa',
        flag: '🇸🇱',
        mask: '00 000000',
        placeholder: '25 123456'
      },
      {
        code: 'SG',
        dialCode: '+65',
        name: 'Cingapura',
        flag: '🇸🇬',
        mask: '0000 0000',
        placeholder: '8123 4567'
      },
      {
        code: 'SK',
        dialCode: '+421',
        name: 'Eslováquia',
        flag: '🇸🇰',
        mask: '000 000 000',
        placeholder: '912 345 678'
      },
      {
        code: 'SI',
        dialCode: '+386',
        name: 'Eslovênia',
        flag: '🇸🇮',
        mask: '00 000 000',
        placeholder: '31 234 567'
      },
      {
        code: 'SB',
        dialCode: '+677',
        name: 'Ilhas Salomão',
        flag: '🇸🇧',
        mask: '00 00000',
        placeholder: '74 21234'
      },
      {
        code: 'SO',
        dialCode: '+252',
        name: 'Somália',
        flag: '🇸🇴',
        mask: '0 0000000',
        placeholder: '7 1234567'
      },
      {
        code: 'ZA',
        dialCode: '+27',
        name: 'África do Sul',
        flag: '🇿🇦',
        mask: '00 000 0000',
        placeholder: '82 123 4567'
      },
      {
        code: 'GS',
        dialCode: '+500',
        name: 'Geórgia do Sul e Ilhas Sandwich do Sul',
        flag: '🇬🇸',
        mask: '00000',
        placeholder: '12345'
      },
      {
        code: 'KR',
        dialCode: '+82',
        name: 'Coreia do Sul',
        flag: '🇰🇷',
        mask: '00-0000-0000',
        placeholder: '10-1234-5678'
      },
      {
        code: 'ES',
        dialCode: '+34',
        name: 'Espanha',
        flag: '🇪🇸',
        mask: '000 00 00 00',
        placeholder: '111 11 11 11'
      },
      {
        code: 'LK',
        dialCode: '+94',
        name: 'Sri Lanka',
        flag: '🇱🇰',
        mask: '00 000 0000',
        placeholder: '77 123 4567'
      },
      {
        code: 'BL',
        dialCode: '+590',
        name: 'São Bartolomeu',
        flag: '🇧🇱',
        mask: '000 00 00 00',
        placeholder: '690 12 34 56'
      },
      {
        code: 'KN',
        dialCode: '+1 869',
        name: 'São Cristóvão e Névis',
        flag: '🇰🇳',
        mask: '000 0000',
        placeholder: '765 1234'
      },
      {
        code: 'VI',
        dialCode: '+1 340',
        name: 'Ilhas Virgens Americanas',
        flag: '🇻🇮',
        mask: '000 0000',
        placeholder: '774 1234'
      },
      {
        code: 'SH',
        dialCode: '+290',
        name: 'Santa Helena',
        flag: '🇸🇭',
        mask: '0000',
        placeholder: '1234'
      },
      {
        code: 'LC',
        dialCode: '+1 758',
        name: 'Santa Lúcia',
        flag: '🇱🇨',
        mask: '000 0000',
        placeholder: '712 3456'
      },
      {
        code: 'SX',
        dialCode: '+1 721',
        name: 'São Martinho (Países Baixos)',
        flag: '🇸🇽',
        mask: '000 0000',
        placeholder: '520 1234'
      },
      {
        code: 'MF',
        dialCode: '+590',
        name: 'São Martinho (França)',
        flag: '🇲🇫',
        mask: '000 00 00 00',
        placeholder: '690 12 34 56'
      },
      {
        code: 'PM',
        dialCode: '+508',
        name: 'Saint Pierre e Miquelon',
        flag: '🇵🇲',
        mask: '00 00 00',
        placeholder: '55 12 34'
      },
      {
        code: 'VC',
        dialCode: '+1 784',
        name: 'São Vicente e Granadinas',
        flag: '🇻🇨',
        mask: '000 0000',
        placeholder: '492 1234'
      },
      {
        code: 'SD',
        dialCode: '+249',
        name: 'Sudão',
        flag: '🇸🇩',
        mask: '00 000 0000',
        placeholder: '91 123 4567'
      },
      {
        code: 'SR',
        dialCode: '+597',
        name: 'Suriname',
        flag: '🇸🇷',
        mask: '000-0000',
        placeholder: '812-3456'
      },
      {
        code: 'SJ',
        dialCode: '+47',
        name: 'Ilhas Svalbard e Jan Mayen',
        flag: '🇸🇯',
        mask: '79 XX XX XX',
        placeholder: '79 12 34 56'
      },
      {
        code: 'SE',
        dialCode: '+46',
        name: 'Suécia',
        flag: '🇸🇪',
        mask: '0XX-XXX XXXX',
        placeholder: '08-123 4567'
      },
      {
        code: 'CH',
        dialCode: '+41',
        name: 'Suíça',
        flag: '🇨🇭',
        mask: '0XX XXX XX XX',
        placeholder: '021 123 45 67'
      },
      {
        code: 'SY',
        dialCode: '+963',
        name: 'Síria',
        flag: '🇸🇾',
        mask: '0XX XXX XXX',
        placeholder: '011 234 567'
      },
      {
        code: 'PF',
        dialCode: '+689',
        name: 'Polinésia Francesa (Tahiti)',
        flag: '🇵🇫',
        mask: 'XX XX XX XX',
        placeholder: '40 12 34 56'
      },
      {
        code: 'TW',
        dialCode: '+886',
        name: 'Taiwan',
        flag: '🇹🇼',
        mask: '09XX XXX XXX',
        placeholder: '0912 345 678'
      },
      {
        code: 'TJ',
        dialCode: '+992',
        name: 'Tajiquistão',
        flag: '🇹🇯',
        mask: 'XX XXX XXXX',
        placeholder: '37 123 4567'
      },
      {
        code: 'TZ',
        dialCode: '+255',
        name: 'Tanzânia',
        flag: '🇹🇿',
        mask: '0XX XXX XXXX',
        placeholder: '022 123 4567'
      },
      {
        code: 'TH',
        dialCode: '+66',
        name: 'Tailândia',
        flag: '🇹🇭',
        mask: '0X-XXXXXXX',
        placeholder: '02-1234567'
      },
      {
        code: 'TG',
        dialCode: '+228',
        name: 'Togo',
        flag: '🇹🇬',
        mask: 'XX XX XX XX',
        placeholder: '22 12 34 56'
      },
      {
        code: 'TK',
        dialCode: '+690',
        name: 'Tokelau',
        flag: '🇹🇰',
        mask: 'XXXXX',
        placeholder: '12345'
      },
      {
        code: 'TO',
        dialCode: '+676',
        name: 'Tonga',
        flag: '🇹🇴',
        mask: 'XXXXX',
        placeholder: '12345'
      },
      {
        code: 'TT',
        dialCode: '+1-868',
        name: 'Trinidad e Tobago',
        flag: '🇹🇹',
        mask: '(868) XXX-XXXX',
        placeholder: '(868) 123-4567'
      },
      {
        code: 'TN',
        dialCode: '+216',
        name: 'Tunísia',
        flag: '🇹🇳',
        mask: 'XX XXX XXX',
        placeholder: '71 123 456'
      },
      {
        code: 'TR',
        dialCode: '+90',
        name: 'Turquia',
        flag: '🇹🇷',
        mask: '0XXX XXX XXXX',
        placeholder: '0212 123 4567'
      },
      {
        code: 'TM',
        dialCode: '+993',
        name: 'Turcomenistão',
        flag: '🇹🇲',
        mask: 'XX XXX XXXX',
        placeholder: '12 345 6789'
      },
      {
        code: 'TC',
        dialCode: '+1-649',
        name: 'Ilhas Turks e Caicos',
        flag: '🇹🇨',
        mask: '(649) XXX-XXXX',
        placeholder: '(649) 123-4567'
      },
      {
        code: 'TV',
        dialCode: '+688',
        name: 'Tuvalu',
        flag: '🇹🇻',
        mask: 'XXXXX',
        placeholder: '12345'
      },
      {
        code: 'UM',
        dialCode: '+1',
        name: 'Territórios Insulares dos EUA',
        flag: '🇺🇲',
        mask: '(XXX) XXX-XXXX',
        placeholder: '(123) 456-7890'
      },
      {
        code: 'UG',
        dialCode: '+256',
        name: 'Uganda',
        flag: '🇺🇬',
        mask: '0XXX XXX XXX',
        placeholder: '041 123 4567'
      },
      {
        code: 'UA',
        dialCode: '+380',
        name: 'Ucrânia',
        flag: '🇺🇦',
        mask: '0XX XXX XXXX',
        placeholder: '044 123 4567'
      },
      {
        code: 'AE',
        dialCode: '+971',
        name: 'Emirados Árabes Unidos',
        flag: '🇦🇪',
        mask: '0X XXX XXXX',
        placeholder: '04 123 4567'
      },
      {
        code: 'US',
        dialCode: '+1',
        name: 'Estados Unidos',
        flag: '🇺🇸',
        mask: '(XXX) XXX-XXXX',
        placeholder: '(123) 456-7890'
      },
      {
        code: 'UY',
        dialCode: '+598',
        name: 'Uruguai',
        flag: '🇺🇾',
        mask: 'X XXX XXXX',
        placeholder: '2 123 4567'
      },
      {
        code: 'UZ',
        dialCode: '+998',
        name: 'Uzbequistão',
        flag: '🇺🇿',
        mask: 'XX XXX XXXX',
        placeholder: '71 123 4567'
      },
      {
        code: 'VU',
        dialCode: '+678',
        name: 'Vanuatu',
        flag: '🇻🇺',
        mask: 'XXXXX',
        placeholder: '12345'
      },
      {
        code: 'VE',
        dialCode: '+58',
        name: 'Venezuela',
        flag: '🇻🇪',
        mask: '0XXX XXX XXXX',
        placeholder: '0212 123 4567'
      },
      {
        code: 'VN',
        dialCode: '+84',
        name: 'Vietnã',
        flag: '🇻🇳',
        mask: '0XX XXX XXXX',
        placeholder: '024 123 4567'
      },
      {
        code: 'WF',
        dialCode: '+681',
        name: 'Ilhas Wallis e Futuna',
        flag: '🇼🇫',
        mask: 'XX XX XX',
        placeholder: '50 12 34'
      },
      {
        code: 'EH',
        dialCode: '+212',
        name: 'Saara Ocidental',
        flag: '🇪🇭',
        mask: '0XX XXX XXX',
        placeholder: '0537 123 456'
      },
      {
        code: 'YE',
        dialCode: '+967',
        name: 'Iémen',
        flag: '🇾🇪',
        mask: '0X XXX XXX',
        placeholder: '01 234 567'
      },
      {
        code: 'ZM',
        dialCode: '+260',
        name: 'Zâmbia',
        flag: '🇿🇲',
        mask: '0XX XXX XXX',
        placeholder: '021 123 456'
      },
      {
        code: 'ZW',
        dialCode: '+263',
        name: 'Zimbábue',
        flag: '🇿🇼',
        mask: '0X XXX XXXX',
        placeholder: '04 123 4567'
      },
      {
        code: 'EX',
        dialCode: '',
        name: 'Exterior',
        flag: '🌐',
        mask: '',
        placeholder: ''
      }
];

const DIAL_CODE_PRIORITY: Record<string, string> = {
  '1': 'US'
};

export function normalizeDialCode(dialCode: string): string {
  return dialCode ? dialCode.replace(/[^0-9]/g, '') : '';
}

export function findCountryByDialCode(dialCode: string): CountryCode | undefined {
  if (!dialCode) {
    return undefined;
  }

  const normalizedDialCode = normalizeDialCode(dialCode);

  const prioritizedCountryCode = DIAL_CODE_PRIORITY[normalizedDialCode];
  if (prioritizedCountryCode) {
    const prioritizedCountry = COUNTRY_CODES.find((country) => country.code === prioritizedCountryCode);
    if (prioritizedCountry) {
      return prioritizedCountry;
    }
  }

  return COUNTRY_CODES.find((country) => normalizeDialCode(country.dialCode) === normalizedDialCode);
}
